'use client';

import {styled} from "@mui/system";
import CustomBox from "@/src/mui-custom/custom-box/custom-box";

const InPressArticleItemCardBox = styled(CustomBox)(() => ({
    display: 'flex',
    alignItems: 'center',
    '& *' : {
        transition: 'all ease-in-out .3s'
    },
}));

export default InPressArticleItemCardBox;
